// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// export const environment = {
//   production: false,
//   loginUrl: 'https://betaapi-suzuki.mint360.in/api/v1', 
//   baseUrl:'https://betaapi-suzuki.mint360.in/api/v1/ho/',
//   baseUrlResetPass:'https://betaapi-suzuki.mint360.in/api/v1/',
//   bucketUrl: 'https://d1sn8rvxrcf2ob.cloudfront.net/assets',
//   mintBucketurl:'https://suzuki-mint-media-bucket.s3.ap-south-1.amazonaws.com/',
//   salesDashboardId: [9,10,12,13,14,15,16], // Stage IDs excluding non-sales (ID: 6). To retrieve all data, pass an empty array.
//   ddDashboardId: [2, 4, 5, 6, 7,14,15,16],
//   chartbaseUrl:'https://charts.mongodb.com/charts-project-0-uhvng',
//   chartdashboardId:'abd36fbc-c150-41ff-881f-36da5a84fcae',
//   bigQueryUrl:'https://beta-reporting-api-suzuki.mint360.in/api/reporting',
//   DD: "https://suzuki.mint360.in/",
//   DP: "https://suzukimotorcycle.mint360.in/",
//   GoLocal: "https://app.glocal360.ai/",
//   DealerSalesExecutive:"https://play.google.com/store/apps/details?id=com.suzuki.salesmanager",
//   Mint360IOS:"https://apps.apple.com/us/app/mint360lms/id6738463708"
// };

// export const environment = {
//   production: false,
//   loginUrl: 'https://suzuki-api.mint360.in/api/v1', 
//   baseUrl:'https://suzuki-api.mint360.in/api/v1/ho/',
//   baseUrlResetPass:'https://suzuki-api.mint360.in/api/v1/',
//   bucketUrl: 'https://d1sn8rvxrcf2ob.cloudfront.net/assets',
//   mintBucketurl:'https://suzuki-mint-media-bucket.s3.ap-south-1.amazonaws.com/',
//   salesDashboardId: [9,10,12,13,14,15,16], // Stage IDs excluding non-sales (ID: 6). To retrieve all data, pass an empty array.
//   ddDashboardId: [2, 4, 5, 6, 7,14,15,16],
//   chartbaseUrl:'https://charts.mongodb.com/charts-project-0-uhvng',
//   chartdashboardId:'abd36fbc-c150-41ff-881f-36da5a84fcae',
//   bigQueryUrl:'https://beta-reporting-api-suzuki.mint360.in/api/reporting' ,
//   // bigQueryUrl:'http://localhost:4401/api/reporting' 
// };


export const environment = {
  production: false,
  loginUrl: 'https://betaapi-suzuki.mint360.in/api/v1', 
  baseUrl:'https://betaapi-suzuki.mint360.in/api/v1/ho/',
  baseUrlResetPass:'https://betaapi-suzuki.mint360.in/api/v1/',
  bucketUrl: 'https://d1sn8rvxrcf2ob.cloudfront.net/assets',
  // mintBucketurl:'https://suzuki-mint-media-bucket-prod.s3.ap-south-1.amazonaws.com/',
  mintBucketurl:'https://d17p6t0a43h3is.cloudfront.net/',
  salesDashboardId: [9,10,12,13,14,15,16], // Stage IDs excluding non-sales (ID: 6). To retrieve all data, pass an empty array.
  ddDashboardId: [2, 4, 5, 6, 7,14,15,16],
  chartbaseUrl:'https://charts.mongodb.com/charts-project-0-uhvng',
  chartdashboardId:'abd36fbc-c150-41ff-881f-36da5a84fcae',
  bigQueryUrl:'https://beta-reporting-api-suzuki.mint360.in/api/reporting' ,
  //bigQueryUrl:'https://reporting-api-suzuki.mint360.in/api/reporting' ,
  
  //bigQueryUrl:'http://localhost:4401/api/reporting',
  DD: "https://suzuki.mint360.in/",
  DP: "https://suzukimotorcycle.mint360.in/",
  GoLocal: "https://app.glocal360.ai/",
  DealerSalesExecutive:"https://play.google.com/store/apps/details?id=com.suzuki.salesmanager",
  Mint360IOS:"https://apps.apple.com/us/app/mint360lms/id6738463708" 
};
// export const environment = {
//   production: false,
//   loginUrl: 'https://suzuki-api.mint360.in/api/v1', 
//   baseUrl:'https://suzuki-api.mint360.in/api/v1/ho/',
//   baseUrlResetPass:'https://suzuki-api.mint360.in/api/v1/',
//   bucketUrl: 'https://d1sn8rvxrcf2ob.cloudfront.net/assets',
//   mintBucketurl:'https://suzuki-mint-media-bucket.s3.ap-south-1.amazonaws.com/',
//   salesDashboardId: [9,10,12,13,14,15,16], // Stage IDs excluding non-sales (ID: 6). To retrieve all data, pass an empty array.
//   ddDashboardId: [2, 4, 5, 6, 7,14,15,16],
//   chartbaseUrl:'https://charts.mongodb.com/charts-project-0-uhvng',
//   chartdashboardId:'abd36fbc-c150-41ff-881f-36da5a84fcae',
//   bigQueryUrl:'https://beta-reporting-api-suzuki.mint360.in/api/reporting' ,
//   // bigQueryUrl:'http://localhost:4401/api/reporting' 
// };



/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
